<template>
  <div :style="detailStyle === 'inline' ? 'width: 100%' : ''">
    <b-container :class="'px-0 mx-0 w-100'" fluid="true"
                 :style="'height: 100%;'">
      <b-row v-if="detailStyle !== 'tab'">
        <b-col class="" style=" margin-right: 15px; margin-left: 15px; margin-top:10px; padding-bottom: 5px">
          <span>
            {{ gridCustomLabel }}
            <small v-if="labelTip" class="form-text text-warning font-weight-bold"
                   style="display: inline; margin-left: 8px;">
              {{ labelTip || '&nbsp;' }}
            </small>
          </span>
        </b-col>
      </b-row>
      <b-row class="p-0 m-0 no-gutters">
        <b-col class="p-0 m-0 no-gutters">

          <VBox
              v-if="firstShow"
              :auto-size="detailStyle === 'tab'"
              :class="(detailStyle !== 'tab' ? ' border' : '')"
              :style="(detailStyle !== 'tab' ?' margin-right: 15px; margin-left: 15px; margin-bottom:15px': '')"
              vbName="det">


            <entities-list
                ref="list"
                v-model="selectedEntity"
                :add-enabled="addEnabled"
                :details-config="detailsConfig"
                :details-master-form-config="masterFormConfig"

                :details-master-id="masterId"
                :details-mode="mode"
                :details-temporary-list="temporaryList"

                :editMultiSelectFromTab.sync="editMultiSelectFromTab"
                :form="formConfig"

                :grid-name="'act-' + masterFormConfig.formId + '-' + formConfig.formClassLong"
                :initialStyle="detailStyle === 'tab' ? '' : 'height:' + inlineHeight + 'px'"
                :listOfDynamicPreparedObjectForColumns="listOfDynamicPreparedObjectForColumns"
                :meta-status="metaStatus"
                :reloadDataForDynamicTab="reloadGridForDynamicTab"
                :select-mode="selectMode"
                :selectedIndex.sync="selectedIndex"
                :selectionSize.sync="selectionSize"
                :showAdd="formConfig.writePermitted && addEnabledFromConfig && !readOnly"
                :showDelete="formConfig.writePermitted && deleteEnabledFromConfig && !readOnly"

                :showDetails="formConfig.readPermitted && detailsConfig.detailsEnabled && !readOnly"
                :showMultiSelect.sync="showMultiSelect"
                :tabName.sync="tabName"
                :toolbox-mixins="toolbox"
                :uniqueDataForColoringDynamicColumns="uniqueDataForColoringDynamicColumns"
                @add="addEntity"
                @delete="deleteEntity"

                @details="showDetails"
                @markReadyToShow="markReadyToShow"
                @rowSelected="capture"
                @row-dblclicked="showDetails"
            >
            </entities-list>
          </VBox>
        </b-col>
      </b-row>


      <FooterNavbar :data-test-path="'form-list-footer:' + formConfig.formClass" v-if="showFooter">
        <CloseButton @close="close"></CloseButton>
      </FooterNavbar>

    </b-container>

    <b-container v-if="textBelowTheListLabel">
      <b-row class="text-center my-3">
        <b-col class="pr-5">
          <span v-html="textBelowTheListLabel"></span>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import FormDetailsConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig";
import {
  getTemporaryId,
} from "@/components/forms/FormModel";


import PermissionsSet from "@/server/PermissionsSet";
import VBox from "@/components/VBox";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import EntitiesList from "@/components/forms/EntitiesList";
import FooterButton from "@/components/navbar/FooterButton";
import FormsActions from "@/components/forms/FormsActions";
import FormsLoader from "@/components/forms/FormsLoader";
import CloseButton from "@/components/navbar/CloseButton";
import TemporaryList from "@/components/forms/TemporaryList"
import BaseFormConfig from "@/server/com/silkplm/engine/forms/schema/BaseFormConfig";
import Rpc from "@/Rpc";
import Contract from "@/server/com/silkplm/model/plm/Contract";
import {ToolboxButton} from "@/components/navbar/toolbox/ToolboxButton";
import FormsAI from "@/components/forms/FormsAI";
import FormModel from "@/components/forms/FormModel";
import TechnologicalDetails from "@/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails";
import {
  checkIfThereAreDynamicFieldsOnTheGrid,
  getFilteredRecordsFromDatabaseWithRows,
  getAllRecordsFromDatabaseWithDynamicCells,
  getAllRecordsFromDatabaseWithDynamicColumns,
  isEqual, getRecordsFromDatabaseWithRowsWhenStreaming, getAllRecordsFromDatabaseWithRows
} from "@/components/forms/customizations/plm/DynamicColumnsService";
import DefaultCellTextRenderer from "@/components/datagrid/DefaultCellTextRenderer.vue";
import GridCellEditor from "@/components/forms/GridCellEditor.vue";
import {VGridVueTemplate} from "@entestat/vue-datagrid";
import {deleteAsStream} from "@/components/forms/customizations/plm/EntitiesListService";
import DialogManager from "@/utils/DialogManager";
import SessionManager from "@/utils/SessionManager";
import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";
import EventBus from "@/utils/EventBus";
import Order from "@/server/com/silkplm/model/plm/Order";
import Dimensions from "@/server/com/silkplm/model/plm/Dimensions";
import DimensionsRows from "@/server/com/silkplm/model/plm/DimensionsRows";
import {
  findFieldValueFromCompanyCompanyConfigurationForm,
  findFieldValueFromCompanyCompanyConfigurationFormField,
  findGridInlineConfiguration
} from "@/components/forms/customizations/plm/EntityEditFormService";
import CompanyConfigurationFormsLoader from "@/components/forms/CompanyConfigurationFormsLoader";
import ApplicationUserOnProduct from "@/server/com/silkplm/model/plm/ApplicationUserOnProduct";
import ApplicationUserOnProductInSeason from "@/server/com/silkplm/model/plm/ApplicationUserOnProductInSeason";
import ApplicationUser from "@/server/com/silkplm/model/users/ApplicationUser";
import Tranche from "@/server/com/silkplm/model/plm/Tranche";

export default {
  name: "DetailsList",
  props: {
    hasWriteAccessToMaster: {default: false},
    showData: {default: false},
    isDetail: {default: false},
    detailsConfig: {type: FormDetailsConfig, required: true},
    masterFormConfig: {type: BaseFormConfig, default: ""},
    masterId: {type: String, default: ""},
    mode: {type: String, default: null},
    otherChangesToSave: {type: Boolean, default: false},
    temporaryList: {type: TemporaryList, default: null},
    showFooter: {default: true},
    editMultiSelectFromTab: {default: false},
    detailStyle: {default: 'tab'},
    inlineHeight: {default: 350},
    extendedEntityEditContainer: {default: null},
    reloadDataForDynamicTab: {default: null},
  },
  components: {CloseButton, FooterButton, EntitiesList, VBox, FooterNavbar},

  async beforeCreate() {

  },
  async created() {
    this.permission = FormsLoader.formPermission(this.masterFormConfig);

    this.$onEvent(ServerEvents.refreshList, async (params) => {
      if (params.fullClassLong === this.formConfig.formClassLong &&
          params.fullClassLong === await DimensionsRows.getRemoteClass() &&
          await checkIfThereAreDynamicFieldsOnTheGrid(this.formConfig)) {
        this.reloadGridForDynamicTab = !this.reloadGridForDynamicTab;
      }
    });
  },

  async mounted() {
    this.assignLabelTip();
    if (this.temporaryList) {
      this.deleteEnabledFromConfig = true;
      this.readOnly = false;
    }
    if (!this.isDetail) {
      this.firstShow = true;
    }
    // cons
    if (this.multiSelect || this.context?.multiSelect) {
      this.selectMode = "range";
    } else {
      if (this.formConfig?.multiGroupDeleteAllow || this.formConfig?.isView) {
        if (this.mode !== "select") {
          this.selectMode = "range";
        }
      } else {
        this.selectMode = "single";
      }
    }
    if (this.detailsConfig.style === "Tab") {
      this.readOnly = false;
    }
    if (this.mode === "NEW") {
      this.masterEntity = this.temporaryList.formModel.originalSource;
      this.addEnabled = true;
      this.addEnabledFromConfig = true;
      this.readOnly = false;
      this.setLabel();
      return;
    }
    this.masterEntity = await Rpc.Forms.getExtendedEntity(this.masterFormConfig.formClassLong, this.masterId);
    const supplement = this.masterEntity?.__supplement__;
    if (supplement) {
      if (!(supplement?.editable)) {
        this.addEnabled = false;
      }
    }

    if (this.detailsConfig.addEnabledFlag?.length) {
      let functionalFlagEntity = CompanyConfigurationFormsLoader.getConfig().companyConfigurationFunctionalFlag;
      this.addEnabledFromConfig = functionalFlagEntity[this.detailsConfig.addEnabledFlag];
    } else {
      this.addEnabledFromConfig = this.detailsConfig.addEnabled;
    }

    if (this.detailsConfig.deleteEnabledFlag?.length) {
      let functionalFlagEntity = CompanyConfigurationFormsLoader.getConfig().companyConfigurationFunctionalFlag;
      this.deleteEnabledFromConfig = functionalFlagEntity[this.detailsConfig.deleteEnabledFlag];
    } else {
      this.deleteEnabledFromConfig = this.detailsConfig.deleteEnabled;
    }

    if (this.masterFormConfig.textBelowTheListClazz === this.formConfig.formClassLong) {
      this.textBelowTheListLabel = FormsAI.getBelowTheLabel(this.masterFormConfig, this.masterEntity);
    }
    this.$onChange(this.masterFormConfig.formClassLong, async (changeEvent) => {
      if (this.masterFormConfig.textBelowTheListExpression?.length) {
        if (changeEvent.instance.id === this.masterId) {
          if (this.masterFormConfig.textBelowTheListClazz === this.formConfig.formClassLong) {
            this.textBelowTheListLabel = FormsAI.getBelowTheLabel(this.masterFormConfig, changeEvent.instance);
          }
        }
      }
    });
    this.$onChange(this.formConfig.formClassLong, async (changeEvent) => {
      if (this.masterFormConfig.textBelowTheListExpression?.length) {
        this.masterEntity = await Rpc.Forms.getExtendedEntity(this.masterFormConfig.formClassLong, this.masterId);
        if (this.masterFormConfig.textBelowTheListClazz === this.formConfig.formClassLong) {
          this.textBelowTheListLabel = FormsAI.getBelowTheLabel(this.masterFormConfig, this.masterEntity);
        }
      }
    });

    if (this.formConfig?.watchedClasses) {
      for (let watchedType of this.formConfig.watchedClasses) {
        this.$onChange(watchedType.className, async (changeEvent) => {
          if (this.masterFormConfig.textBelowTheListExpression?.length) {
            this.masterEntity = await Rpc.Forms.getExtendedEntity(this.masterFormConfig.formClassLong, this.masterId);
            this.textBelowTheListLabel = FormsAI.getBelowTheLabel(this.masterFormConfig, this.masterEntity);
          }
        });
      }
    }

    if (await checkIfThereAreDynamicFieldsOnTheGrid(this.formConfig)) {
      await this.loadDynamicData();
      await this.createDynamicColumns()
    }
    this.setLabel();
  },

  methods: {

    assignLabelTip() {
      let config = findGridInlineConfiguration(this.masterFormConfig, this.formConfig.originalEntityPlural + " (INLINE)");
      if (config) {
        this.labelTip = config.labelTip;
      }
    },

    setReadOnly(readOnly) {
      this.readOnly = readOnly;
    },
    setLabel() {
      let customLabel = findFieldValueFromCompanyCompanyConfigurationForm(this.formConfig.formId, "alternativeMenuLabel");
      this.gridCustomLabel = customLabel?.length ? customLabel : this.formConfig.entityPlural;
    },
    capture() {
    },

    refreshColumns() {
      this.metaStatus = this.temporaryList && this.temporaryList.hasErrors;
      this.$refs.list?.refreshColumns();
    },

    foundDetailsToClassFieldConfig() {
      for (let field of this.formConfig.shadowFields) {
        for (let detailClass of this.formConfig.detailToClasses) {
          if (detailClass === field.foreignClass) {
            return field;
          }
        }
      }
      for (let field of this.formConfig.fields) {
        for (let detailClass of this.formConfig.detailToClasses) {
          if (detailClass === field.foreignClass) {
            return field;
          }
        }
      }
    },

    async findOnlyIdsToDisplay(formClazz) {
      if (this.mode === "NEW") {
        if (this.formConfig.formClassLong === ApplicationUserOnProductInSeason.getRemoteClass()) {
          let ids = await Rpc.plm.services.DictionaryService.listMerchants();
          return ids;
        }
      }
      let recordFormModel = new FormModel(FormsLoader.detectFormConfig(this.formConfig.formClassLong));
      let detailsToClassFieldConfig = this.foundDetailsToClassFieldConfig();
      let detailsToClassFieldName = detailsToClassFieldConfig.fieldName;
      let originalSource = await recordFormModel.newEntity();
      originalSource[detailsToClassFieldName] = this.masterId;
      recordFormModel.createMode(originalSource);

      let recordsDisplayOnList = await Rpc.Forms.listDictionaryForMultipleAdd(formClazz, this.formConfig.formClassLong,
          originalSource, this.masterId, this.masterFormConfig.formClassLong).lock();
      let onlyIds = [];
      recordsDisplayOnList.forEach(record => {
        onlyIds.push(record.id);
      })
      return onlyIds;
    },

    async addEntitiesMultiAddMode() {
      let foreignKeyFieldName = this.formConfig.multiAddForeignKey;
      let foreignKeyFieldConfig = null;
      for (let field of this.formConfig.fields) {
        if (field.fieldName === foreignKeyFieldName) {
          foreignKeyFieldConfig = field;
        }
      }
      if (!foreignKeyFieldConfig) {
        for (let field of this.formConfig.shadowFields) {
          if (field.fieldName === foreignKeyFieldName) {
            foreignKeyFieldConfig = field;
          }
        }
      }
      let foreignClass = foreignKeyFieldConfig.foreignClass;
      let onlyIds = await this.findOnlyIdsToDisplay(foreignClass);
      // if (this.temporaryList) {
      //   onlyIds = onlyIds.filter(id => {
      //     let index = _.findIndex(this.temporaryList.items, [foreignKeyFieldName, id]);
      //     return index === -1;
      //   });
      // }
      let records = await (await FormsActions.showMultiSelectListFromIds(foreignClass, {
        showAdd: false,
        showDelete: false
      }, onlyIds)).getResult();
      let recordsToSave = [];
      let detailsToClassFieldConfig = this.foundDetailsToClassFieldConfig();
      let detailsToClassFieldName = detailsToClassFieldConfig.fieldName;

      if (records?.length) {
        for (let record of records) {
          let recordFormModel = new FormModel(FormsLoader.detectFormConfig(this.formConfig.formClassLong));
          let originalSource = await recordFormModel.newEntity();
          originalSource[foreignKeyFieldName] = record.id;
          let masterId = null;
          if (this.masterId?.length) {
            masterId = this.masterId;
          }
          originalSource[detailsToClassFieldName] = masterId;
          recordFormModel.createMode(originalSource);

          // to jest quick fix i złe rozwiązanie, nie zadziała generycznie ale pozostawiam to póki co tak
          if (this.temporaryList) {
            if (originalSource instanceof ApplicationUserOnProduct || originalSource instanceof ApplicationUserOnProductInSeason) {
              let entityLabel = await Rpc.Forms.getEntityLabel(ApplicationUser.getRemoteClass(), record.id);
              originalSource.__supplement__.fkInstances.merchantId = entityLabel;
              originalSource.__supplement__.fkInstances.productInSeasonId = entityLabel;
              originalSource.__supplement__.fkLabels.merchantId = entityLabel;
              originalSource.__supplement__.fkLabels.productInSeasonId = entityLabel;
            }
          }
          if (this.temporaryList) {
            recordFormModel.masterTemporaryList = this.temporaryList;
            await recordFormModel.saveNewToTmpList();
          } else {
            recordsToSave.push(recordFormModel.originalSource);
          }
        }
        if (!this.temporaryList) {
          await Rpc.Forms.addEntities(this.formConfig.formClassLong, recordsToSave).lock();
        }
        if (this.temporaryList?.formModel) {
          await this.temporaryList.formModel.validate();
        }
      }
    },

    async addEntity() {
      if (this.formConfig.hasConditionalAdd) {
        const addInfo = await Rpc.Forms.canAdd(this.formConfig.formClassLong, this.masterId);
        if (addInfo) {
          await DialogManager.info($tr("cantAdd", "Can't add"), addInfo);
          return;
        }
      }

      if (this.temporaryList) { // new mode
        // await FormsActions.createTmpDetail(this.masterFormConfig, this.detailsConfig, this.temporaryList);
        await this.addEntitiesMultiAddMode();
        return;
      }

      if (this.formConfig.multiAddForeignKey) {
        await this.addEntitiesMultiAddMode();
        return;
      }
      await FormsActions.createDetail(this.masterFormConfig, this.detailsConfig, this.masterId,
          {masterEntityInstance: this.extendedEntityEditContainer?.entityInstance});
    },

    async deleteEntity() {
      let res = await this.$emit("delete");
      if (this.selectMode === "single") {
        await FormsActions.delete(this.selectedEntity, true);
        this.selectedEntity = null;
        this.$refs.list.afterDeleteEntity();

      } else if (this.selectMode === "range" && this.selectedEntity.length === 1) {
        if (this.selectedEntity.dataStream && this.selectedEntity.dataStream.defaultSelectAll) {
          if (await DialogManager.yesNo($tr('detailsList.deleting', 'Deleting #{1}', this.formConfig.entityPlural),
              $tr('detailsList.sure.delete', 'Are you sure you want to delete selected #{1}?', this.formConfig.entityPlural), false)) {
            await deleteAsStream(this.selectedEntity, this.formConfig);
          }
        } else {
          let res = (this.customDelete || await FormsActions.delete(this.selectedEntity[0], true));
          if (res) {
            if (this.temporaryList) {
              let index = _.findIndex(this.temporaryList.items, ['__id__', this.selectedEntity[0].__id__]);
              if (index !== -1) {
                this.temporaryList.items.splice(index, 1);
              }
            }
          }
          this.afterDeleteEntity();
        }
      } else if (this.selectMode === "range" && this.selectedEntity.length > 1) {
        if (this.selectedEntity.dataStream && this.selectedEntity.dataStream.defaultSelectAll) {
          if (await DialogManager.yesNo($tr('detailsList.deleting', 'Deleting #{1}', this.formConfig.entityPlural),
              $tr('detailsList.sure.delete.many.pt.1', 'Are you sure you want to delete selected ') + "<b>" + this.selectedEntity.length + "</b>" + $tr('detailsList.sure.delete.many.pt.2', ' elements from #{1}?', this.formConfig.entityPlural), false)) {
            await deleteAsStream(this.selectedEntity, this.formConfig);
          }
        } else {
          let res = (this.customDelete || await FormsActions.deleteList(this.selectedEntity, true, this.temporaryList));
          if (res) {
            if (this.temporaryList) {
              this.selectedEntity.forEach(el => {
                let index = _.findIndex(this.temporaryList.items, ['__id__', el.__id__]);
                if (index !== -1) {
                  this.temporaryList.items.splice(index, 1);
                }
              })

            }
          }
          this.afterDeleteEntity();
        }
      }
      if (this.temporaryList?.formModel) {
        await this.temporaryList.formModel.validate();
      }
    },

    afterDeleteEntity() {
      if (!this.customDelete) {
        this.selectedEntity = null;
        this.$refs.list.afterDeleteEntity();
      }
    },

    async showDetails() {
      if (this.temporaryList) {
        let inst = this.getSelectedEntity();
        let form = await FormsActions.editTmpEntity(this.formConfig, inst, {
          detailsConfig: this.detailsConfig,
          showDelete: this.deleteEnabledFromConfig
        });
        await form.getResult();
        this.$refs.list.updateTemporaryInstance(inst);
      } else {
        await FormsActions.editDetail(this.getSelectedEntity(), this.detailsConfig, this.masterId,
            {detailsConfig: this.detailsConfig, showDelete: this.deleteEnabledFromConfig});
      }
    },

    markReadyToShow() {
      this.$emit("markReadyToShow")
    },

    getSelectedEntity() {
      if (this.selectMode === "range") {
        if (!this.selectedEntity || this.selectedEntity.length === 0) {
          return null;
        }
        return this.selectedEntity[0];
      }
      return this.selectedEntity;
    },

    close() {
      this.$emit('cancel');
    },

    /**
     * @param masterInstance {RpcClass}
     * @param fieldName {string}
     * @param validatedField {FormValidatedField}
     * @param detailConf {FormDetailsConfig}
     */
    async reloadTabDetail(masterInstance, fieldName, validatedField, detailConf) {
      // console.log("Reload request");
    },

    notifyShow() {
      if (this.formConfig.formClassLong === Tranche.getRemoteClass()) {
        this.firstShow = !this.firstShow;
        this.firstShow = !this.firstShow;
      }
      this.firstShow = true;
    },
    async exportContract() {
      await Rpc.plm.services.ContractService.generateOrderContract(this.masterId);
    },

    async loadDynamicData() {
      if (await checkIfThereAreDynamicFieldsOnTheGrid(this.formConfig)) {
        let dynamicRowsFormConfig;
        if (SessionManager.featureFlagsSet[FeatureFlag.STREAMING_LISTS] && this.formConfig.streamingMode) {
          [this.dynamicRows, dynamicRowsFormConfig] = await getRecordsFromDatabaseWithRowsWhenStreaming(this.formConfig, this.formConfig.formClassLong, this.context ? this.context.onlyIds : null, this.context ? this.context.excludedIds : null);
        } else {
          [this.dynamicRows, this.dynamicRowsFormConfig] = await getFilteredRecordsFromDatabaseWithRows(this.formConfig, this.masterId);
        }
        [this.dynamicCells, this.dynamicCellFormConfig] = await getAllRecordsFromDatabaseWithDynamicCells(this.formConfig.dynamicCells, this.dynamicRows);
        if (this.dynamicCells.length > 0) {
          [this.dynamicColumns, this.dynamicColsFormConfig, this.uniqueDataForColoringDynamicColumns] =
              await getAllRecordsFromDatabaseWithDynamicColumns(this.formConfig.dynamicColumns, this.dynamicCells, this.dynamicCellFormConfig);
        }
      }
    },

    async createDynamicColumns() {

      if (this.dynamicRows.length !== 0 && this.dynamicCells.length !== 0
          && this.dynamicColumns.length === Object.keys(this.dynamicRows[0]?.__supplement__?.dynamicColumns).length) {

        let filedConfigFromDynamicCellsToEdit = this.dynamicCellFormConfig.fields.filter(field => field.fieldName === this.dynamicCellFormConfig.cellValueFieldForDynamicColumns);
        this.listOfDynamicPreparedObjectForColumns = [];
        for (let i = 0; i < this.dynamicColumns.length; i++) {
          const column = this.dynamicColumns[i];

          let label = FormsAI.getEntityLabel(null, column.columnLabelEntity)
          let tempComputedColsFromEntitiesList = {
            autoSize: false,
            // cellProperties: computedCols[2].cellProperties,
            colId: column.columnEntity.id,
            colsManager: null,
            dataGrid: this,
            fieldConfig: filedConfigFromDynamicCellsToEdit[0],
            formConfig: this.dynamicCellFormConfig,
            template: DefaultCellTextRenderer,
            gridOrder: this.formConfig.fields[this.formConfig.fields.length - 1].gridOrder += 100,
            id: column.columnEntity.id,
            name: label,
            prop: "__" + column.columnEntity.id + "__",
            searchable: false,
            size: 100,
            sortable: false,
            toFilterStr: null,
            toStr: null,
            visible: true,
            dynamicColumn: true,
            base: column.columnEntity.base,
            editable: column.columnEntity.editable
          }

          if (this.uniqueDataForColoringDynamicColumns !== null && this.dynamicColsFormConfig !== undefined &&
              this.dynamicColsFormConfig.fieldByWhichColoringWillBeDistinguishedForDynamicColumns !== null) {
            let redValue = 175;
            for (let value of this.uniqueDataForColoringDynamicColumns) {
              redValue += 30;
              let valueFromFormConfig = this.dynamicColsFormConfig.fieldByWhichColoringWillBeDistinguishedForDynamicColumns
              if (column.columnEntity[valueFromFormConfig] === value && redValue <= 255) {
                tempComputedColsFromEntitiesList.cssHStyle = {"background": `rgb(${redValue}, 211, 255)`};
                tempComputedColsFromEntitiesList.customCssHStyleValue = redValue;
              }
            }
          }

          tempComputedColsFromEntitiesList.cellTemplate = VGridVueTemplate(tempComputedColsFromEntitiesList.template);

          this.listOfDynamicPreparedObjectForColumns.push(tempComputedColsFromEntitiesList);
        }
      } else {
        this.listOfDynamicPreparedObjectForColumns = [];
      }
    }

  },
  watch: {
    editMultiSelectFromTab: function (val) {
      this.$emit("update:editMultiSelectFromTab", val);
    },
    selectionSize: function (val) {
      this.$emit("update:selectionSize", this.selectionSize);
    },
    showMultiSelect: function (val) {
      this.$emit("update:showMultiSelect", this.showMultiSelect);
    },
    tabName: function (val) {
      this.$emit("update:tabName", this.tabName);
    },
    reloadDataForDynamicTab: async function (val, oldVal) {
      await this.loadDynamicData();
      await this.createDynamicColumns()
      this.reloadGridForDynamicTab = val;
    },
    reloadGridForDynamicTab: async function (val, oldVal) {
      await this.loadDynamicData();
      await this.createDynamicColumns()
    },
  },
  data: function () {
    let toolbox = [];
    let clazz = Contract.getRemoteClass();
    if (this.detailsConfig.formConfig.formClassLong === clazz) {
      let exportContractButton = new ToolboxButton().withIcon("file-arrow-down").withLabel($tr("exportContract", "Export Contract"))
          .withAction((btn) => this.exportContract());
      toolbox.push(exportContractButton);
    }
    return {
      addEnabled: true,
      addEnabledFromConfig: null,
      deleteEnabledFromConfig: null,
      selectedEntity: null,
      selectedIndex: null,
      metaStatus: false,
      /** @type {FormConfig}*/
      formConfig: FormsLoader.detectFormConfig(this.detailsConfig.detailsViewClass ?? this.detailsConfig.detailsClass),
      grid: null,
      permissions: new PermissionsSet(),
      selectMode: this.multiSelect || this.context?.multiSelect ? "range" : "single",
      multiSelectAutoOn: false,
      readOnly: true,
      toolbox: [...toolbox],
      listOfDynamicPreparedObjectForColumns: [],
      textBelowTheListLabel: null,
      selectionSize: 0,
      showMultiSelect: false,
      tabName: false,
      dynamicColumns: [],
      dynamicRows: [],
      dynamicCells: [],
      dynamicColsFormConfig: null,
      dynamicRowsFormConfig: null,
      dynamicCellFormConfig: null,
      uniqueDataForColoringDynamicColumns: null,
      reloadGridForDynamicTab: true,
      gridCustomLabel: null,
      componentAlreadyLoaded: false,
      firstShow: false,
      labelTip: null
    }
  },
}
</script>

<style scoped>

</style>